import React, { useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { FiShare2 } from "react-icons/fi";
import { message } from "antd";
import Service from "services/service";
import { useNavigate } from "react-router-dom";

const ListingProductCart = ({
  title,
  brand,
  price,
  oldPrice,
  discount,
  isNewArrival = false,
  image,
  colour,
  productId,
}) => {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const navigate = useNavigate();

  const handleWishlist = async (e) => {
    e.stopPropagation();
    const token = localStorage.getItem("authToken");
    if (!token) {
      message.info("Please login to add to wishlist");
      navigate("/signup");
      return;
    }
    try {
      if (isWishlisted) {
        await Service.removeWishlistService({ productId });
        setIsWishlisted(false);
        message.success("Removed from wishlist");
      } else {
        await Service.addOrUpdateWishlistService({ items: [{ product: productId }] });
        setIsWishlisted(true);
        message.success("Added to wishlist");
      }
    } catch {
      message.error("Something went wrong");
    }
  };

  const handleShare = (e) => {
    e.stopPropagation();
    const url = `${window.location.origin}/product/${productId}`;
    if (navigator.share) {
      navigator.share({ title, text: `Check out ${title} on Rekha Collection!`, url });
    } else {
      navigator.clipboard.writeText(url);
      message.success("Link copied!");
    }
  };

  return (
    <div className="product-details">
      <div>
        <div className="product-details__column--new">
          {isNewArrival && (
            <button className="New_Arrival_Button">New Arrival</button>
          )}
          <div className="SpotLigth_Image12">
            <img src={image} alt="Productlist_image" />
          </div>
          <div className="product-card__actions">
            <button className="product-card__btn" onClick={handleWishlist} aria-label="Wishlist">
              {isWishlisted ? <FaHeart className="product-card__icon--filled" /> : <FaRegHeart />}
            </button>
            <button className="product-card__btn" onClick={handleShare} aria-label="Share">
              <FiShare2 />
            </button>
          </div>
        </div>
      </div>
      <div className="product-details__column--price">
        <div className="product-details__column--details">
          <div className="product-details__row--images">
            <div className="product-details__row--views">
              {colour.map((e, i) => (
                <div
                  key={i}
                  className="product-details__view"
                  style={{ backgroundColor: e }}
                ></div>
              ))}
            </div>
          </div>
          <h1 className="product-details__text--title ui heading size-headings">
            {title}
          </h1>
          <p className="product-details__text--brand ui text size-textlg">
            {brand}
          </p>
        </div>
        <div className="product-details__row--offer">
          <div className="product-details__row--prices">
            <p className="product-details__text--price ui text size-textlg">
              ₹{price}
            </p>
            <p className="product-details__text--old-price ui text size-textlg">
              ₹{oldPrice}
            </p>
          </div>
          <p className="product-details__text--discount ui text size-textlg">
            ({discount} OFF)
          </p>
        </div>
      </div>
    </div>
  );
};

export default ListingProductCart;
